export type DragBaseConfig = {
    closeSpeedThreshold: number;
    flickMinDistancePx: number;
};

export type EdgeBaseConfig = {
    maxPx: number;
    decay: number;
    resistance: number;
};

export const DEFAULT_DRAG_BASE: DragBaseConfig = {
    // 「フリックで閉じる」と判定する速度しきい値（px/ms）
    closeSpeedThreshold: 0.5,
    // 速度判定を有効にする最小移動量（px）
    flickMinDistancePx: 24,
};

export const DEFAULT_EDGE_BASE: EdgeBaseConfig = {
    // edge時に引っ張れる最大距離（px）
    maxPx: 56,
    // edgeの減衰係数（大きいほど伸びにくい）
    decay: 260,
    // drawer逆方向ドラッグ時の抵抗係数（0-1, 小さいほど重い）
    resistance: 0.08,
};

export function readNumberSetting(raw: string | undefined, fallback: number, min: number): number {
    const parsed = raw ? Number.parseFloat(raw) : Number.NaN;
    if (!Number.isFinite(parsed)) return fallback;
    return Math.max(min, parsed);
}

export function readOptionalNumberSetting(raw: string | undefined, min: number): number | null {
    const parsed = raw ? Number.parseFloat(raw) : Number.NaN;
    if (!Number.isFinite(parsed)) return null;
    return Math.max(min, parsed);
}

export function readCssNumber(el: Element, prop: string, fallback: number): number {
    const raw = getComputedStyle(el).getPropertyValue(prop).trim();
    const parsed = Number.parseFloat(raw);
    return Number.isFinite(parsed) ? parsed : fallback;
}
